import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import chartNode from './nodes';
import perfil from '../../images/perfil3.jpg';
//import messages from '../../redux/messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getFuncStructure = (id, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FUNCIONAL_STRUCTURE,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(iType === 1 ? `/api/app/Formal_unidadjerarquia/?orga=${id}` : `/api/app/Funcional_unidadjerarquia/?orga=${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    let aStructures = [];
    const {data, count} = resp.data;
    data.forEach(item => {
      aStructures = [...aStructures, chartNode({
        id: item.id,
        partentNodeId: item.padre,
        nodeIcon: null,
        nodeImage: item.lider ? {
          url: item.lider && item.lider.foto ? `${process.env.REACT_APP_URL}/media/${item.lider.foto}` : perfil,
          width: 100,
          height: 100,
          centerTopDistance: 0,
          centerLeftDistance: 0,
          cornerShape: "ROUNDED",
          shadow: true,
          borderWidth: 0,
        } : null,
        template: `<div class="d-flex ${ item.pertenece_empresa ? '' : 'bg-danger' } w-100 h-100 justify-content-center aling-items-center flex-column">
        <h6 class="text-uppercase font-weight-bold text-center">${item.nombre}</h6>
        ${ item.lider && item.lider.nombre ? '<h6 class="text-center"><small class="text-uppercase font-weight-bold ">' + item.lider.nombre + '</small></h6>' : '' }`
      })];
    });

    dispatch({
      type: actions.GET_FUNCIONAL_STRUCTURE,
      payload: {
        structures: data,
        astructures: aStructures,
        structureLength: count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_FUNCIONAL_STRUCTURE,
      payload: false
    });
  }
}

export const getFuncNodesEmployee = (nodeid, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FUNCIONAL_STRUCTURE,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(iType === 1 ? `/api/app/Formal_arbol_viewset/?unidad=${nodeid}` : `/api/app/Funcional_arbol_viewset/?unidad=${nodeid}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });

    let aStructures = [];
    const {unidad, padre, equipo, empleados} = resp.data;
    empleados.map(item => {
      aStructures = [...aStructures, chartNode({
        id: `emp${item.id}`,
        partentNodeId: `uni${item.padre}`,
        nodeIcon: null,
        nodeImage: {
          url: item.foto ? `${process.env.REACT_APP_URL}/media/${item.foto}` : perfil,
          width: 100,
          height: 100,
          centerTopDistance: -20,
          centerLeftDistance: 0,
          cornerShape: "ROUNDED",
          shadow: true,
          borderWidth: 0,
        },
        template: `<div class="d-flex ${ item.pertenece_empresa ? '' : 'bg-danger' } w-100 h-100 justify-content-center aling-items-center flex-column">
        <h6 class="text-uppercase font-weight-bold text-center">${item.nombre}</h6>
        ${ item.puesto_nombre ? '<h6 class="text-center"><small class="text-uppercase font-weight-bold ">' + item.puesto_nombre + '</small></h6></div>' : '' }`
      })];
    });

    equipo.map(item => {
      aStructures = [...aStructures, chartNode({
        id: `uni${item.id}`,
        partentNodeId: `uni${item.padre}`,
        nodeIcon: null,
        nodeImage: item.lider ? {
          url: item.lider && item.lider.foto ?  `${process.env.REACT_APP_URL}/media/${item.lider.foto}` : perfil,
          width: 100,
          height: 100,
          centerTopDistance: 0,
          centerLeftDistance: 0,
          cornerShape: "ROUNDED",
          shadow: true,
          borderWidth: 0,
        } : null,
        template: `<div class="d-flex ${ item.pertenece_empresa ? '' : 'bg-danger' } w-100 h-100 justify-content-center aling-items-center flex-column">
        <h6 class="text-uppercase font-weight-bold text-center">${item.nombre}</h6>
        ${item.lider && item.lider.nombre ? '<h6 class="text-center"><small class="text-uppercase font-weight-bold ">' + item.lider.nombre + '</small></h6></div>' : '' }`
      })];
    });
  
    aStructures = [...aStructures, chartNode({
      id: `uni${padre.id}`,
      partentNodeId: null,
      nodeIcon: null,
      nodeImage: padre.lider ? {
        url: padre.lider && padre.lider.foto ?  `${process.env.REACT_APP_URL}/media/${padre.lider.foto}` : perfil,
        width: 100,
        height: 100,
        centerTopDistance: 0,
        centerLeftDistance: 0,
        cornerShape: "ROUNDED",
        shadow: true,
        borderWidth: 0,
      } : null,
      template: `<div class="d-flex ${ padre.pertenece_empresa ? '' : 'bg-danger' } w-100 h-100 justify-content-center aling-items-center flex-column">
      <h6 class="text-uppercase font-weight-bold text-center">${padre.nombre}</h6>
      ${padre.lider && padre.lider.nombre ? '<h6 class="text-center"><small class="text-uppercase font-weight-bold ">' + padre.lider.nombre + '</small></h6>' : '' }`
    })];
   
    aStructures = [...aStructures, chartNode({
      id: `uni${unidad.id}`,
      partentNodeId: `uni${unidad.padre}`,
      nodeIcon: null,
      nodeImage: unidad.lider ? {
        url: unidad.lider && unidad.lider.foto ?  `${process.env.REACT_APP_URL}/media/${unidad.lider.foto}` : perfil,
        width: 100,
        height: 100,
        centerTopDistance: 0,
        centerLeftDistance: 0,
        cornerShape: "ROUNDED",
        shadow: true,
        borderWidth: 0,
      } : null,
      template: `<div class="d-flex ${ unidad.pertenece_empresa ? '' : 'bg-danger' } w-100 h-100 justify-content-center aling-items-center flex-column">
      <h6 class="text-uppercase font-weight-bold text-center">${unidad.nombre}</h6>
      ${unidad.lider && unidad.lider.nombre ? '<h6 class="text-center"><small class="text-uppercase font-weight-bold ">' + unidad.lider.nombre + '</small></h6>' : '' }`
    })];
    
    dispatch({
      type: actions.GET_FUNCIONAL_STRUCTURE,
      payload: {
        structures: resp.data,
        astructures: aStructures
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_FUNCIONAL_STRUCTURE,
      payload: false
    });
  }
}